import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// MAIN COMPONENT
export default function InputAppendCol({ children, className, cols = {}, ...props }) {
  return (
    <Form.Col
      {...props}
      cols={{ xs: 24, sm: 12, ...cols }}
      className={clsx('p-0 px-sm-2 py-sm-0', children && 'my-2 my-sm-0')}
    >
      <div className={clsx('d-inline large text-gray-600', className)}>{children}</div>
    </Form.Col>
  );
}
